export default "__VITE_ASSET__Yeb$Cb2j__"